export default "__VITE_ASSET__yEPQGWIT__"